var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCompete28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8317 16.8113C13.8906 16.8358 13.9468 16.8586 14 16.8797C14.0532 16.8586 14.1094 16.8358 14.1683 16.8113C14.6481 16.6114 15.2729 16.3093 15.8832 15.8985C17.156 15.0419 18 13.982 18 12.6538V12V9V7V6H10V7V9V12V12.6538C10 13.982 10.844 15.0419 12.1168 15.8985C12.7271 16.3093 13.3519 16.6114 13.8317 16.8113ZM8 11.874V9H5.12602C5.4878 10.4056 6.59439 11.5122 8 11.874ZM8 7H5H3V8C3 8.34071 3.0284 8.67479 3.08296 9C3.50448 11.5125 5.4875 13.4955 8 13.917C8.05481 13.9262 8.10986 13.9347 8.16516 13.9424C8.85281 16.5445 11.5215 18.0058 13 18.6312V22H10C8.89543 22 8 22.8954 8 24H20C20 22.8954 19.1046 22 18 22H15V18.6312C16.4785 18.0058 19.1472 16.5445 19.8348 13.9424C19.8901 13.9347 19.9452 13.9262 20 13.917C22.5125 13.4955 24.4955 11.5125 24.917 9C24.9716 8.67479 25 8.34071 25 8V7H23H20V6V4H18H10H8V6V7ZM20 9V11.874C21.4056 11.5122 22.5122 10.4056 22.874 9H20Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompete28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;